import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateFormData } from "../../redux-store/formDataSlice";

const bg = `${EASYCOMMERCE.assets}admin/img/icons/bg.png`;

const Account = ({ isAPIKeyVisible }) => {
    const dispatch = useDispatch();
    const { name, email , apiKey } = useSelector((state) => state.formData);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        dispatch(updateFormData({ key: name, value: value }));
    };

    useEffect(() => {
        dispatch(
            updateFormData({
                key: "name",
                value: EASYCOMMERCE.user.data.display_name,
            })
        );

        dispatch(
            updateFormData({
                key: "email",
                value: EASYCOMMERCE.user.data.user_email,
            })
        );
        dispatch(
            updateFormData({
                key: "apiKey",
                value: EASYCOMMERCE.apiKey,
            })
        );
    }, []);

    return (
        <div
            className="bg-cover bg-center w-full flex flex-col items-center"
            style={{
                backgroundImage: `url(${bg})`,
                backgroundSize: "1100px 500px",
                backgroundRepeat: "no-repeat",
            }}
        >
            <div className="w-[40%] bg-[#FFFFFF] flex flex-col p-10 border-2 border-[#E0E8FF] rounded-xl space-y-4">
                {/* Name Input */}
                <div className="flex flex-col space-y-2">
                    <label className="text-ec-body text-[16px] font-medium">
                        Your Name
                    </label>
                    <input
                        type="text"
                        name="name"
                        className="easycommerce-wizard-input w-full"
                        placeholder="Enter your name"
                        value={name}
                        onChange={handleInputChange}
                    />
                    <p className="text-ec-placeholder text-xs">
                        Please enter your full name.
                    </p>
                </div>

                {/* Email Input */}
                <div className="flex flex-col space-y-2">
                    <label className="text-ec-body text-[16px] font-medium">
                        Your Email
                    </label>
                    <input
                        type="email"
                        name="email"
                        className="easycommerce-wizard-input w-full"
                        placeholder="Enter your email"
                        value={email}
                        onChange={handleInputChange}
                    />
                    <p className="text-ec-placeholder text-xs">
                        We'll send an API key to this email to connect your store to our system for easy, streamlined store management.
                    </p>
                </div>

                {isAPIKeyVisible && (
                    <div className="flex flex-col space-y-2">
                        <label className="text-ec-body text-[16px] font-medium">
                            API Key
                        </label>
                        <input
                            type="text"
                            name="apiKey"
                            className="easycommerce-wizard-input w-full"
                            placeholder="Enter your API key"
                            value={apiKey}
                            onChange={handleInputChange}
                        />
                        <p className="text-ec-placeholder text-xs">
                            Please enter the API key just sent to the email you provided above.
                        </p>
                    </div>
                )}

                <div className="flex items-center space-y-2">
                    <p className="text-ec-placeholder text-[14px]">
                        <input
                            type="checkbox"
                            name="dont_share_data"
                            onChange={handleInputChange}
                        />
                        I prefer not to <strong>share my anonymous usage data</strong>, even if it helps improve EasyCommerce.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Account;
